export default __webpack_public_path__ + "static/media/pencil_icon.6c151d51.svg";